import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import gql from 'graphql-tag';
import { ToastService } from 'ng-uikit-pro-standard';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { cliente_proveedor } from 'src/app/shared/object/cliente_proveedor.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ValidadoresService } from 'src/app/shared/validadores/validadores';

@Component({
  selector: 'app-clientes-form-datos-financieros',
  templateUrl: './form-datos-financieros.component.html',
  styleUrls: ['../clientes.component.scss'],
  providers: [SecurityService, ValidadoresService],
})
export class FormDatosFinancierosComponent implements OnInit {
  // Outputs
  @Output() onSuccess: EventEmitter<void> = new EventEmitter<void>();

  // @Input() optionsTipoCobro: Array<any> = [];
  @Input() optionsCondicionPago: Array<any> = [];
  @Input() optionsListaPrecios: Array<any> = [];

  private client: GraphQLClient = null;

  // Forms
  public formDatosFinancierosModal: FormGroup;

  // Data & Tmp
  public rutEmpresa: number;
  public sucursalEmpresa: number;
  public codigoModulo: number;
  public rutUsuario: number;

  // Utils
  private log: any;

  constructor(
    client: GraphQLClient,
    private accesolocalstorage: SecurityService,
    private clog: ConsoleService,
    public validadores: ValidadoresService,
    public rutService: RutService,
    public toastService: ToastService,
    private messageRendererService: MessageRendererService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService
  ) {
    this.log = this.clog.log('MANTENEDOR-CLIENTES/FORM DATOS FINANCIEROS');
    this.client = client;
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo());
    this.codigoModulo = 1;
    this.rutUsuario = Number(this.accesolocalstorage.getRutUsuario());

    this.createForm();
  }

  createForm() {
    this.formDatosFinancierosModal = this.fb.group({
      // tipoCobro: [0, [Validators.required, Validators.min(1)]],
      condicionPago: [0, [Validators.required, Validators.min(1)]],
      listaPrecios: [0, [Validators.required, Validators.min(1)]],
      limiteCredito: [0],
      tieneLimiteCredito: [false],
      descuentoMaximo: [0, [Validators.max(99.99), Validators.min(0)]],
      clieneAfectoReglasComerciales: [true],

      // tipo_cliente_codigo: [0, [Validators.required]],
    });
  }

  loadAndShow(cliente: cliente_proveedor, onDatosCargados?: () => void) {
    this.log('load', cliente);
    const self = this;
    this.showModalModificarDtoFinancierosParte2(cliente, onDatosCargados);
  }

  showModalModificarDtoFinancierosParte2(cliente, onDatosCargados?: () => void) {
    const self = this;
    this.client.query(
      {
        query: gql`
          query ($rutEmpresa: Decimal, $rutCliente: Decimal, $codigoDireccion: Decimal) {
            cliente_proveedor {
              obtenerSegunId(entidad: { rut: $rutCliente, empresa_rut: $rutEmpresa }) {
                respuesta {
                  limite_credito
                  descuento_maximo
                  afecto_reglas_comerciales
                  tipo_cobro_codigo
                }
              }
            }

            direccion {
              obtenerSegunId(entidad: { cliente_proveedor_rut: $rutCliente, empresa_rut: $rutEmpresa, codigo: $codigoDireccion }) {
                respuesta {
                  condicion_pago_codigo
                }
              }
            }

            condicionReferencia: direccion {
              obtenerSegunFiltro(
                filtro: {
                  exacto: {
                    empresa_rut: $rutEmpresa
                    cliente_proveedor_rut: $rutCliente
                    direccion_completa: ""
                    nombre: ""
                    activo: true
                  }
                }
                paginaActual: 0
                cantidadRegistrosPorPagina: -1
              ) {
                respuesta {
                  registros {
                    condicion_pago_codigo
                    es_principal
                  }
                }
              }
            }
          }
        `,
        variables: {
          rutEmpresa: Number(self.rutEmpresa),
          rutCliente: cliente.rut, //self.rutCliente,
          codigoDireccion: cliente.codigo_direccion,
        },
        fetchPolicy: 'no-cache',
      },
      function (respuesta) {
        const cpResp = respuesta.data.cliente_proveedor.obtenerSegunId.respuesta;
        if (!cpResp) {
          return;
        }
        const { afecto_reglas_comerciales, descuento_maximo, limite_credito, tipo_cobro_codigo } = cpResp;
        const { respuesta: respuestaDireccion } = respuesta.data.direccion.obtenerSegunId;
        let condicion_pago_codigo = -1;
        if (respuestaDireccion) {
          condicion_pago_codigo = respuestaDireccion.condicion_pago_codigo;
        }
        if (!condicion_pago_codigo || condicion_pago_codigo <= 0) {
          const condicionRefData = ((respuesta.data as any).condicionReferencia || {}).respuesta || {}; // GraphQL sin tipos generados; alias condicionReferencia
          const registros = condicionRefData.registros || [];
          const principal = registros.find((d) => d.es_principal && d.condicion_pago_codigo > 0);
          const otraConCondicion = registros.find((d) => d.condicion_pago_codigo > 0);
          const condicionReferencia = (principal && principal.condicion_pago_codigo) || (otraConCondicion && otraConCondicion.condicion_pago_codigo);
          if (condicionReferencia > 0) {
            condicion_pago_codigo = condicionReferencia;
          }
        }
        const { lista_precio_codigo, rut } = cliente;

        self.log(
          'afecto_reglas_comerciales',
          afecto_reglas_comerciales,
          'descuento_maximo',
          descuento_maximo,
          'limite_credito',
          limite_credito,
          'tipo_cobro_codigo',
          tipo_cobro_codigo,
          'condicion_pago_codigo',
          condicion_pago_codigo,
          'lista_precio_codigo',
          lista_precio_codigo,
          'rut',
          rut
        );

        self.formDatosFinancierosModal.reset();
        // self.formDatosFinancieros.get('rutCliente').setValue(rut);
        // self.formDatosFinancierosModal.get('tipoCobro').setValue(tipo_cobro_codigo);
        self.formDatosFinancierosModal.get('condicionPago').setValue(condicion_pago_codigo);
        self.formDatosFinancierosModal.get('listaPrecios').setValue(lista_precio_codigo);
        self.formDatosFinancierosModal.get('limiteCredito').setValue(limite_credito);
        self.formDatosFinancierosModal.get('tieneLimiteCredito').setValue(limite_credito === 0);
        self.formDatosFinancierosModal.get('descuentoMaximo').setValue(descuento_maximo);
        self.formDatosFinancierosModal.get('clieneAfectoReglasComerciales').setValue(afecto_reglas_comerciales);
        if (onDatosCargados) {
          onDatosCargados();
        }
      }
    );
  }

  setModoSoloLectura(soloLectura: boolean) {
    if (soloLectura) {
      this.formDatosFinancierosModal.disable();
    } else {
      this.formDatosFinancierosModal.enable();
      this.formDatosFinancierosHandleLimCred();
    }
  }

  formDatosFinancierosHandleLimCred() {
    if (this.formDatosFinancierosModal.get('tieneLimiteCredito').value) {
      this.formDatosFinancierosModal.get('limiteCredito').setValue(0);
      this.formDatosFinancierosModal.get('limiteCredito').disable();
    } else {
      this.formDatosFinancierosModal.get('limiteCredito').enable();
    }
  }

  validate() {
    this.setDefaults();
    this.formValidatorsService.validateAllFormFields(this.formDatosFinancierosModal);
    return this.formDatosFinancierosModal.valid;
  }

  setDefaults() {
    this.setDefault('limiteCredito');
    this.setDefault('descuentoMaximo');
  }

  setDefault(prop: string, value: any = '0') {
    if (!this.formDatosFinancierosModal.get(prop).value) this.formDatosFinancierosModal.get(prop).setValue(value);
  }

  getFormData() {
    return this.formDatosFinancierosModal.getRawValue();
  }

  reset() {
    this.formValidatorsService.reset(this.formDatosFinancierosModal);
    this.formDatosFinancierosModal.get('clieneAfectoReglasComerciales').setValue(true);
  }

  setlimiteCredito(limit: number) {
    this.formDatosFinancierosModal.get('limiteCredito').setValue(limit);
    if (limit > 0) {
      this.formDatosFinancierosModal.get('tieneLimiteCredito').setValue(true);
    } else {
      this.formDatosFinancierosModal.get('tieneLimiteCredito').setValue(false);
    }
  }

  SetListaPrecio(lista: number) {
    this.formDatosFinancierosModal.get('listaPrecios').setValue(lista);
  }

  SetDescuentoMaximo(descuentomax: number) {
    this.formDatosFinancierosModal.get('descuentoMaximo').setValue(descuentomax);
  }
}
